import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import List from '../../components/List';
import ListItem from '../../components/ListItem';
import LoadingIndicator from '../../components/LoadingIndicator';
import EvenemangListItem from '../../containers/EvenemangListItem';
import EvenemangListItemCard from '../../containers/EvenemangListItemCard';

import Masonry from 'react-masonry-component';

const masonryOptions = {
  transitionDuration: 0,
};

const imagesLoadedOptions = { background: '.my-bg-image-el' };

const styles = theme => ({
  root: {
    flexGrow: 1,
    justifyContent: 'left',
  },
  control: {
    padding: theme.spacing(2),
  },
  griditem: {
    [theme.breakpoints.up('xs')]: {
      width: '100%',
      height: 'auto',
    },
    [theme.breakpoints.up('sm')]: {
      width: '50%',
    },
    [theme.breakpoints.up('md')]: {
      width: '50%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '25%',
    },
    [theme.breakpoints.up('xl')]: {
      width: '20%',
    },
    [theme.breakpoints.up('xxl')]: {
      width: '16.5%',
    },
  },
  griditemhome: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },

    [theme.breakpoints.up('sm')]: {
      width: '50%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '33%',
    },
  },
});
function EvenemangList(props) {
  const {
    loading,
    error,
    evenemang,
    masonryview,
    listview,
    user,
    userid,
    favoriter,
  } = props;
  const { classes } = props;
  let homepage = false;
  let listclass = classes.griditem;

  if (props.home) {
    homepage = true;
    listclass = classes.griditemhome;
  }
  let limit = 0;
  let limitset = false;
  if (props.limit) {
    limit = props.limit;
    limitset = true;
  }
  /* if (loading) {
    return <List component={LoadingIndicator} />;
  } */

  if (error !== false) {
    const ErrorComponent = () => (
      <ListItem item="Something went wrong, please try again!" />
    );
    return <List component={ErrorComponent} />;
  }

  if (evenemang !== false && masonryview) {
    return (
      <Masonry
        className="my-gallery-class" // default ''
        colums={4} // default {}
        options={masonryOptions} // default {}
        disableImagesLoaded={false} // default false
        updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
        imagesLoadedOptions={imagesLoadedOptions} // default {}
      >
        {evenemang.map((card, i) => {
          if (limitset && i >= limit) {
          } else {
            return (
              <Grid className={listclass} key={i} item xs={12}>
                <EvenemangListItemCard
                  user={user}
                  userid={userid}
                  item={card}
                  key={i}
                  favoriter={favoriter}
                />
              </Grid>
            );
          }
        })}
      </Masonry>
    );
  }
  if (evenemang !== false && listview) {
    return (
      <Grid
        container
        justifyContent="flex-start"
        className={classes.root}
        spacing={6}
      >
        {evenemang.map((card, i) => (
          <EvenemangListItem user={user} userid={userid} item={card} key={i} />
        ))}
      </Grid>
    );
  }
  return null;
}

EvenemangList.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.any,
  evenemang: PropTypes.any,
};

export default withStyles(styles)(EvenemangList);
